var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 15.697V17a14.166 14.166 0 11-8.401-12.948",
    stroke: "#474747",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 5.667L17 19.847l-4.25-4.25",
    stroke: "#474747",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzQgMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMS4xNjY3IDE1LjY5NjZWMTdDMzEuMTY1IDIwLjA1NDkgMzAuMTc1OCAyMy4wMjc0IDI4LjM0NjYgMjUuNDc0MkMyNi41MTc1IDI3LjkyMSAyMy45NDY0IDI5LjcxMSAyMS4wMTY4IDMwLjU3NzJDMTguMDg3MiAzMS40NDMzIDE0Ljk1NjIgMzEuMzM5MyAxMi4wOTA1IDMwLjI4MDZDOS4yMjQ5MiAyOS4yMjE5IDYuNzc4MyAyNy4yNjUzIDUuMTE1NTcgMjQuNzAyNUMzLjQ1MjgzIDIyLjEzOTcgMi42NjMwOCAxOS4xMDgxIDIuODY0MDggMTYuMDU5N0MzLjA2NTA5IDEzLjAxMTQgNC4yNDYwOCAxMC4xMDk4IDYuMjMwOTQgNy43ODc0OUM4LjIxNTc5IDUuNDY1MjEgMTAuODk4MiAzLjg0Njc2IDEzLjg3OCAzLjE3MzUxQzE2Ljg1NzggMi41MDAyNiAxOS45NzU0IDIuODA4MjggMjIuNzY1OSA0LjA1MTY0IiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMxLjE2NjcgNS42NjY2M0wxNyAxOS44NDc1TDEyLjc1IDE1LjU5NzUiIHN0cm9rZT0iIzQ3NDc0NyIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgCheckPlus as ReactComponent };